// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import { observable } from 'mobx';
import Request from '../api/Request';
import Cookies from '../util/Cookies';

export class UserStore {
    @observable user?: any = null;

    async login(username: string, password: string) {
        const response = await Request.post('/auth/login', {
            username: username,
            password: password
        }, {}, false);

        if (response.code && response.code === 401) {
            throw response;
        }

        let token = '';

        let currentDate = new Date();

        currentDate.setSeconds(currentDate.getSeconds() + 86400);
        token = response.token;

        Cookies.set('token', token, { expires: currentDate, path: '/'});

        this.user = await Request.get('/me', {});
    }

    refreshUser(user: any, token: string) {
        let currentDate = new Date();

        currentDate.setSeconds(currentDate.getSeconds() + 86400);

        Cookies.set('token', token, { expires: currentDate, path: '/'});

        this.user = user;
    }

    async setUser() {
        this.user = await Request.get('/me', {});
    }

    logout() {
        Cookies.remove('token', { path: '/' });
        this.user = null;
    }
}

export default new UserStore();